import { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import coinPic from "../img/coin-svgrepo-com2.svg";
import sharee from "../img/share.png";
import curPic from "../img/dollar-svgrepo-com.svg";
import tamam from "./img/flags/coinImg.png";
import emami from "./img/flags/emamiImg.png";
var scroll = require("scroll");
var page = require("scroll-doc")();
var ease = require("ease-component");

function addComma(str) {
  var objRegex = new RegExp("(-?[0-9]+)([0-9]{3})");

  while (objRegex.test(str)) {
    str = str.replace(objRegex, "$1,$2");
  }

  return str;
}
function gregorianToJalali(data) {
  let x = data.split(" ");
  let [date, time] = x;
  let [year, month, day] = date.split("-");
  if (date && time && month && year && day) {
    if (month[0] === "0") month = month.slice(1);
    if (day[0] === "0") day = day.slice(1);
    let [hour, minute, second] = time.split(":");
    hour = parseInt(hour, 10);
    minute = parseInt(minute, 10);
    second = parseInt(second, 10);
    [hour, minute, second] = setTime(hour, minute, second);

    // converter
    let gy = parseInt(year, 10);
    let gm = parseInt(month, 10);
    let gd = parseInt(day, 10);
    let g_d_m, jy, jm, jd, gy2, days;
    g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
    gy2 = gm > 2 ? gy + 1 : gy;
    days =
      355666 +
      365 * gy +
      ~~((gy2 + 3) / 4) -
      ~~((gy2 + 99) / 100) +
      ~~((gy2 + 399) / 400) +
      gd +
      g_d_m[gm - 1];
    jy = -1595 + 33 * ~~(days / 12053);
    days %= 12053;
    jy += 4 * ~~(days / 1461);
    days %= 1461;
    if (days > 365) {
      jy += ~~((days - 1) / 365);
      days = (days - 1) % 365;
    }
    if (days < 186) {
      jm = 1 + ~~(days / 31);
      jd = 1 + (days % 31);
    } else {
      jm = 7 + ~~((days - 186) / 30);
      jd = 1 + ((days - 186) % 30);
    }
    return {
      year: jy,
      month: jm,
      day: jd,
      hour,
      minute,
      second,
    };
  } else {
    return {};
  }
}
const setTime = (h, m, s) => {
  m += 30;
  h += 3;
  if (m >= 60) {
    const newM = m % 60;
    h += 1;
    m = newM;
  }
  if (h >= 24) {
    const newH = h % 24;
    h = newH;
  }
  return [h, m, s];
};
const Table = ({ coin, cur, scrolling }) => {
  const [coindate, setCoinDate] = useState({});
  const setCoinUpdateTime = useCallback(() => {
    setCoinDate(
      gregorianToJalali(
        coin[0]?.updatedAt?.split("T")[0] +
          " " +
          coin[0]?.updatedAt?.split("T")[1].split(".")[0]
      )
    );
  }, [coin]);
  useEffect(() => {
    setCoinUpdateTime();
  }, [coin]);

  const [curdate, setCurDate] = useState({});
  const setCurUpdateTime = useCallback(() => {
    setCurDate(
      gregorianToJalali(
        cur[0]?.updatedAt?.split("T")[0] +
          " " +
          cur[0]?.updatedAt?.split("T")[1].split(".")[0]
      )
    );
  }, [cur]);
  useEffect(() => {
    setCurUpdateTime();
  }, [cur]);

  const [scrollTable, setScrollTable] = scrolling;
  const navigate = useNavigate();
  const coinloc = useRef();

  useEffect(() => {
    if (scrollTable === "cur") {
      scroll.top(page, 0);
    }
    if (scrollTable === "coin") {
      scroll.top(
        page,
        coinloc?.current.offsetTop - (coinloc?.current.offsetHeight + 35)
      );
    }
  }, [scrollTable]);

  const n = Math.floor(cur?.length / 2);
  const [firstHalf, secondHalf] = [
    cur?.slice(0, n),
    cur?.slice(n, cur?.length),
  ];

  return (
    <div>
      <div className="tableinfo">
        <div className="d-flex justify-content-center">
          <p
            className="text-center "
            style={{ display: "inline-block", marginLeft: "10px" }}
          >
            ارز / Currency
          </p>
          <img src={curPic} className="imgTable"></img>
        </div>
        {curdate.hour !== undefined ? (
          <div className="text-center">
            {" "}
            <p className="d-inline" style={{ fontWeight: "200" }}>
              آخرین بروز رسانی :{" "}
            </p>
            <p
              className="d-inline"
              style={{
                fontFamily: "Yekan",
                fontSize: "15px",
                fontFamily: "-webkit-pictograph",
              }}
            >
              <span style={{ marginRight: "5px" }}>
                {curdate
                  ? curdate?.year + "/" + curdate?.month + "/" + curdate?.day
                  : " "}{" "}
              </span>
              <span>
                {curdate?.hour
                  ? curdate?.hour +
                    ":" +
                    curdate?.minute +
                    ":" +
                    curdate?.second
                  : " "}{" "}
              </span>
            </p>
          </div>
        ) : null}
      </div>
      <table className="tableapp" style={{ margin: "0 auto", width: "95%" }}>
        <thead>
          <tr>
            <th>پرچم</th>
            <th>نماد</th>
            <th>ارز</th>
            <th>خرید</th>
            <th>فروش</th>
          </tr>
        </thead>
        <tbody>
          {firstHalf?.map((e) => {
            return (
              <tr key={e !== undefined && e.id}>
                <td>
                  <img
                    src={require(`./img/flags/${
                      e !== undefined && e.Currency.symbol
                    }.png`)}
                    className="flag"
                    alt="پرچم کشور ها"
                  ></img>
                </td>
                <td>{e !== undefined && e.Currency.symbol}</td>
                <td>{e !== undefined && e.Currency.name}</td>
                <td
                  style={{
                    color: `${e?.pBuyPrice > e?.buyPrice ? "red" : "green"}`,
                    fontFamily: "sans-serif",
                  }}
                >
                  {addComma(e?.buyPrice.toString())}
                </td>
                <td
                  style={{
                    color: `${e?.pSellPrice > e?.sellPrice ? "red" : "green"}`,
                    fontFamily: "sans-serif",
                  }}
                >
                  {addComma(e?.sellPrice.toString())}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="tableinfo">
        <div className="d-flex justify-content-center">
          <p
            className="text-center "
            style={{ display: "inline-block", marginLeft: "10px" }}
          >
            ارز / Currency
          </p>
          <img src={curPic} className="imgTable"></img>
        </div>
        {curdate.hour !== undefined ? (
          <div className="text-center">
            {" "}
            <p className="d-inline" style={{ fontWeight: "200" }}>
              آخرین بروز رسانی :{" "}
            </p>
            <p
              className="d-inline"
              style={{
                fontFamily: "Yekan",
                fontSize: "15px",
                fontFamily: "-webkit-pictograph",
              }}
            >
              <span style={{ marginRight: "5px" }}>
                {curdate
                  ? curdate.year + "/" + curdate.month + "/" + curdate.day
                  : " "}{" "}
              </span>
              <span>
                {curdate
                  ? curdate.hour + ":" + curdate.minute + ":" + curdate.second
                  : " "}{" "}
              </span>
            </p>
          </div>
        ) : null}
      </div>
      <table className="tableapp" style={{ margin: "0 auto", width: "95%" }}>
        <thead>
          <tr>
            <th>پرچم</th>
            <th>نماد</th>
            <th>ارز</th>
            <th>خرید</th>
            <th>فروش</th>
          </tr>
        </thead>
        <tbody>
          {secondHalf?.map((e) => {
            return (
              <tr key={e !== undefined && e.id}>
                <td>
                  <img
                    src={require(`./img/flags/${
                      e !== undefined && e.Currency.symbol
                    }.png`)}
                    className={`flag ${
                      e.Currency.symbol === "DKK" ? "w-28" : ""
                    }`}
                    alt="پرچم کشور ها"
                  />
                </td>
                <td>{e !== undefined && e.Currency.symbol}</td>
                <td>{e !== undefined && e.Currency.name}</td>
                <td
                  style={{
                    color: `${e?.pBuyPrice > e?.buyPrice ? "red" : "green"}`,
                    fontFamily: "sans-serif",
                  }}
                >
                  {addComma(e?.buyPrice.toString())}
                </td>
                <td
                  style={{
                    color: `${e?.pSellPrice > e?.sellPrice ? "red" : "green"}`,
                    fontFamily: "sans-serif",
                  }}
                >
                  {addComma(e?.sellPrice.toString())}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="tableinfo" ref={coinloc}>
        <div className="d-flex justify-content-center">
          <p
            className="text-center "
            style={{ display: "inline-block", marginLeft: "10px" }}
          >
            سکه / Coin
          </p>
          <img src={coinPic} className="imgTable"></img>
        </div>
        {coindate.hour !== undefined ? (
          <div className="text-center">
            {" "}
            <p className="d-inline" style={{ fontWeight: "200" }}>
              آخرین بروز رسانی :{" "}
            </p>
            <p
              className="d-inline"
              style={{
                fontFamily: "Yekan",
                fontSize: "15px",
                fontFamily: "-webkit-pictograph",
              }}
            >
              <span style={{ marginRight: "5px" }}>
                {coindate
                  ? coindate?.year + "/" + coindate?.month + "/" + coindate.day
                  : " "}{" "}
              </span>
              <span>
                {coindate?.hour !== undefined
                  ? coindate?.hour +
                    ":" +
                    coindate?.minute +
                    ":" +
                    coindate?.second
                  : " "}{" "}
              </span>
            </p>
          </div>
        ) : null}
      </div>
      <table className="tableapp" style={{ margin: "0 auto", width: "95%" }}>
        <thead>
          <tr>
            <th>نماد</th>
            <th>سکه</th>
            <th>خرید</th>
            <th>فروش</th>
          </tr>
        </thead>
        <tbody>
          {coin?.map((e) => {
            return (
              <tr key={e.id}>
                <td>
                  <img
                    src={e.id === 2 ? emami : tamam}
                    className={`flag flagIcon ${
                      e?.id === 3
                        ? "nim"
                        : e?.id === 4
                        ? "rob"
                        : e?.id === 5
                        ? "yek"
                        : ""
                    }`}
                    alt="نماد سکه ها"
                  />
                </td>
                <td>{e.Coin.name}</td>
                <td
                  style={{
                    color: `${e.pBuyPrice > e.buyPrice ? "red" : "green"}`,
                    fontFamily: "sans-serif",
                  }}
                >
                  {addComma(e.buyPrice.toString())}
                </td>
                <td
                  style={{
                    color: `${e.pSellPrice > e.sellPrice ? "red" : "green"}`,
                    fontFamily: "sans-serif",
                  }}
                >
                  {addComma(e.sellPrice.toString())}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div
        className="telmisinfo"
        style={{ marginBottom: "100px", color: "#fff" }}
      >
        <p className="text-center">طراحی شده توسط تلمیس</p>
      </div>
    </div>
  );
};
export default Table;
